document.addEventListener("DOMContentLoaded", function () {
  const btn__description = document.querySelector(".btn-lear-more__collection");

  btn__description.addEventListener("click", (e) => {
    e.preventDefault();
    const more__description = document.querySelector(
      ".cc-learn-more__description"
    );

    if (btn__description.matches(".read-more--open")) {
      btn__description.classList.remove("read-more--open");
      more__description.classList.remove("show_text_full");
      btn__description.textContent = "Leer más";
    } else {
      btn__description.classList.add("read-more--open");
      more__description.classList.add("show_text_full");
      btn__description.textContent = "Leer menos";
    }
  });
});
